import { Model } from '@/clients/http'

import { OrderNoteHttpParams, OrderNoteResponses } from '@/types'

export class OrderNoteModel extends Model {
  public static readonly correlations = {
    GET_LIST: 'GET_ORDER_NOTE_LIST',
    GET_BY_ID: 'GET_ORDER_NOTE_BY_ID',
    CREATE: 'CREATE_ORDER_NOTE',
    UPDATE: 'UPDATE_ORDER_NOTE',
    DELETE: 'DELETE_ORDER_NOTE',
  }

  public static readonly endpoints = {
    getList: (props?: OrderNoteHttpParams.GetList) =>
      this.createEndpoint({
        url: '/api/backoffice/order-note',
        params: props?.params,
        query: props?.query,
      }),

    getById: (props?: OrderNoteHttpParams.GetById) =>
      this.createEndpoint({
        url: '/api/backoffice/order-note/:id',
        params: props?.params,
        query: props?.query,
      }),

    create: (props?: OrderNoteHttpParams.Create) =>
      this.createEndpoint({
        url: '/api/backoffice/order-note',
        params: props?.params,
        query: props?.query,
      }),

    update: (props?: OrderNoteHttpParams.Update) =>
      this.createEndpoint({
        url: '/api/backoffice/order-note/:id',
        params: props?.params,
        query: props?.query,
      }),

    delete: (props?: OrderNoteHttpParams.Delete) =>
      this.createEndpoint({
        url: '/api/backoffice/order-note/:id',
        params: props?.params,
        query: props?.query,
      }),
  }

  public static readonly getList = async (props?: OrderNoteHttpParams.GetList) => {
    return this.createHttpRequest<OrderNoteResponses.GetList, OrderNoteResponses.GetListError>({
      correlationKey: this.correlations.GET_LIST,
      payload: {
        method: 'get',
        url: this.endpoints.getList(props),
        useBearerToken: true,
      },
      store: props?.store,
    })
  }

  public static readonly create = async (props: OrderNoteHttpParams.Create) => {
    return this.createHttpRequest<OrderNoteResponses.Create, OrderNoteResponses.CreateError>({
      correlationKey: this.correlations.CREATE,
      payload: {
        method: 'post',
        url: this.endpoints.create(props),
        body: props.body,
        useBearerToken: true,
      },
      store: props?.store,
    })
  }

  public static readonly update = async (props: OrderNoteHttpParams.Update) => {
    return this.createHttpRequest<OrderNoteResponses.Update, OrderNoteResponses.UpdateError>({
      correlationKey: this.correlations.UPDATE,
      payload: {
        method: 'put',
        url: this.endpoints.update(props),
        body: props.body,
        useBearerToken: true,
      },
      store: props?.store,
    })
  }

  public static readonly delete = async (props: OrderNoteHttpParams.Delete) => {
    return this.createHttpRequest<OrderNoteResponses.Delete, OrderNoteResponses.DeleteError>({
      correlationKey: this.correlations.DELETE,
      payload: {
        method: 'delete',
        url: this.endpoints.delete(props),
        useBearerToken: true,
      },
      store: props?.store,
    })
  }
}
